import { render, staticRenderFns } from "./ActGeneralQuestions.vue?vue&type=template&id=79026001&"
import script from "./ActGeneralQuestions.vue?vue&type=script&lang=js&"
export * from "./ActGeneralQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports